/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_6_P1Inputs */

const en_terms_section_6_p1 = /** @type {(inputs: Terms_Section_6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you send through the contact form — your email address and your message — is used to reply to you and to talk about the work, and for nothing else.`)
};

const lv_terms_section_6_p1 = /** @type {(inputs: Terms_Section_6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktformā nosūtītais — Jūsu e-pasta adrese un ziņa — tiek izmantots, lai Jums atbildētu un pārrunātu darbu, un nekam citam.`)
};

/**
* | output |
* | --- |
* | "What you send through the contact form — your email address and your message — is used to reply to you and to talk about the work, and for nothing else." |
*
* @param {Terms_Section_6_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_6_p1 = /** @type {((inputs?: Terms_Section_6_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_6_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_6_p1(inputs)
	return en_terms_section_6_p1(inputs)
});